import React, { useRef, useState } from 'react';
import { Header } from '@homeplay/components';
import LottoAssistantProvider from './context/lottoAssistantProvider';
import LottoAssistantErrorBoundary from './components/LottoAssistantErrorBoundary';
import WelcomeScreen from './components/WelcomeScreen';
import ChatContainer from './components/ChatContainer';
import ChatInput from './components/ChatInput';
import CartDrawer from './components/CartDrawer';
import MyBetsDrawer from './components/MyBetsDrawer';
import FlyToCartAnimation from './components/FlyToCartAnimation';
import { OnboardingProvider, OnboardingTour } from './components/Onboarding';
import {
  useAssistantActions,
  useAssistantState,
} from './hooks/useLottoAssistantContext';
import { useAutoScroll } from './hooks/useAutoScroll';
import { useCartSync } from './hooks/useCartSync';
import classes from './LottoAssistant.module.scss';

const LottoAssistantUI = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMyBetsOpen, setIsMyBetsOpen] = useState(false);
  const [myBetsArgs, setMyBetsArgs] = useState(null);
  const cartIconRef = useRef(null);
  const messagesEndRef = useRef(null);

  const { messages, flyingTicketSource } = useAssistantState();
  const { setFlyingTicketSource } = useAssistantActions();
  const scrollToLastMessage = useAutoScroll(messagesEndRef, messages);
  useCartSync();

  return (
    <>
      <Header />
      <div className={classes.Wrapper}>
        {messages.length === 0 ? (
          <WelcomeScreen />
        ) : (
          <ChatContainer
            messagesEndRef={messagesEndRef}
            onScrollToLastMessage={scrollToLastMessage}
          />
        )}

        <ChatInput
          cartIconRef={cartIconRef}
          onOpenCart={() => setIsCartOpen(true)}
          onOpenMyBets={() => {
            setMyBetsArgs(null);
            setIsMyBetsOpen(true);
          }}
        />

        <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />

        <MyBetsDrawer
          isOpen={isMyBetsOpen}
          onClose={() => setIsMyBetsOpen(false)}
          args={myBetsArgs}
        />

        {flyingTicketSource && (
          <FlyToCartAnimation
            sourceElement={flyingTicketSource}
            targetElement={cartIconRef.current}
            onComplete={() => setFlyingTicketSource(null)}
          />
        )}

        <OnboardingTour />
      </div>
    </>
  );
};

const LottoAssistant = () => {
  return (
    <OnboardingProvider>
      <LottoAssistantProvider>
        <LottoAssistantErrorBoundary>
          <LottoAssistantUI />
        </LottoAssistantErrorBoundary>
      </LottoAssistantProvider>
    </OnboardingProvider>
  );
};

export default LottoAssistant;
